// Jump-gate travel client state (Phase 6 Block A).
//
// Lightweight — just two fields that control the travel overlay and
// prevent opening the galaxy-map while mid-jump. Applied by the
// server-message-reducer arms for jumpStarted / traveling / jumpCompleted.

import type { StationId } from "../../shared/stations.ts";

export type TravelClientState = {
  travelingTo: StationId | null;
  completesAt: number | null;
};

export function createTravelState(): TravelClientState {
  return { travelingTo: null, completesAt: null };
}

// Set in-flight travel state (jumpStarted or traveling ephemeral).
export function applyTravelStarted(state: TravelClientState, target: StationId, completesAt: number): void {
  state.travelingTo = target;
  state.completesAt = completesAt;
}

// Clear travel state on jumpCompleted.
export function applyTravelCleared(state: TravelClientState): void {
  state.travelingTo = null;
  state.completesAt = null;
}
